<template>
    <div>
        <headerNotice routerName="修改商品"></headerNotice>
        <!-- 基本信息 -->
        <div class="baseInfo" v-loading="loading">
            <h1>
                基本信息
                <span>
                    （&nbsp;
                    <i class="mustStar">*</i>&nbsp;必填）
                </span>
            </h1>
            <div class="table">
                <el-form :model="formData" class="signUp_Form" label-width="200px">
                    <el-row>
                        <el-col :span="10">
                            <el-form-item label="商品名称：" :rules="{'required':true}">
                                <el-input
                                    v-model="formData.title"
                                    size="small"
                                    maxlength="50"
                                    placeholder="请输入商品名称，<50个字"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="商品编号：">
                                <el-input
                                    class="inputStyle"
                                    v-model="formData.itemCode"
                                    size="small"
                                    placeholder="请输入商品编号"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <!-- <el-col :span="10">
                            <el-form-item :rules="{'required':true}" label="商品分类：">
                                <el-select v-model="formData.cateID" placeholder="请选择商品分类">
                                    <el-option
                                        v-for="item in cateList"
                                        :key="item.cateID"
                                        :label="item.cateName"
                                        :value="item.cateID"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>-->
                        <el-col :span="10">
                            <el-form-item label="商品单位：" :rules="{'required':true}">
                                <el-select v-model="formData.unit" placeholder="请选择商品单位">
                                    <el-option
                                        v-for="item in unitList"
                                        :key="item.unitID"
                                        :label="item.unitName"
                                        :value="item.unitID"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="20">
                            <el-form-item :rules="{'required':true}" label="展示类目：">
                                <ul class="displayCate" v-loading="cateLoading">
                                    <li v-for="(item, index) in showCateIds" :key="index">
                                        <div class="firstName">{{item.cateName}}</div>
                                        <div class="groupBox">
                                            <el-checkbox-group v-model="formData.showCateIds">
                                                <el-checkbox
                                                    @change="cateCheckboxChange(index,index2)"
                                                    :disabled="item2.disabled"
                                                    class="radio"
                                                    v-for="(item2, index2) in item.cates"
                                                    :key="index2"
                                                    :label="item2.cateID"
                                                >{{item2.cateName}}</el-checkbox>
                                            </el-checkbox-group>
                                        </div>
                                    </li>
                                </ul>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10">
                            <el-form-item label="品牌：">
                                <el-select v-model="formData.brandID" placeholder="请选择商品品牌">
                                    <el-option label="暂无" :value="0"></el-option>
                                    <el-option
                                        v-for="item in brandList"
                                        :key="item.brandID"
                                        :label="item.brandName"
                                        :value="item.brandID"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="10">
                            <el-form-item label="库存预警值：">
                                <el-input
                                    class="inputStyle"
                                    v-model="formData.stockWaring"
                                    size="small"
                                    placeholder="请输入库存预警值"
                                ></el-input>
                            </el-form-item>
                        </el-col> -->
                    </el-row>
                    <el-row>
                        <el-col :span="15">
                            <el-form-item label="关联关键词：">
                                <el-input
                                    class="inputStyle"
                                    v-model="formData.keyword"
                                    maxlength="50"
                                    size="small"
                                    placeholder="请输入关联关键词，≤50个字符，多个关键词以英文逗号' , '隔开"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="6">
                            <el-form-item label="业务员提成（%）：">
                                <el-input
                                    type="number"
                                    class="inputStyle"
                                    v-model="formData.commissionPrec"
                                    size="small"
                                ></el-input>
                            </el-form-item>
                        </el-col> -->
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="上下架：">
                                <el-switch
                                    v-model="formData.status"
                                    :active-value="1"
                                    :inactive-value="0"
                                    active-text="上架"
                                    inactive-text="下架"
                                ></el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="16">
                            <el-form-item label="标签（最多选择3个）：">
                                <el-checkbox-group v-model="formData.labelIds" :min="0" :max="3">
                                    <el-checkbox
                                        v-for="(item,index) in labelList"
                                        :key="index"
                                        :label="item.labelID"
                                    >{{item.labelName}}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <!-- <h1>分销提成设置</h1>
            上一级推广提成（%）
            <div class="linkIpt">
                <el-input type="number" size="small" v-model="formData.directCommissionRate" placeholder="请输入上一级推广提成"></el-input>
            </div>
            上二级推广提成（%）
            <div class="linkIpt">
                <el-input  type="number" size="small" v-model="formData.indirectCommissionRate" placeholder="请输入上二级推广提成"></el-input>
            </div> -->
            <!-- <h1>分销提成设置</h1>
            <div >
                 <el-form :model="formData" class="signUp_Form" label-width="250px">
                     <el-row>
                        <el-col >
                            <el-form-item label="上一级推广提成(%):">
                                <el-input
                                   class="inputStyle direct"
                                    v-model="formData.directCommissionRate"
                                    size="small"
                                    placeholder="请输入上一级推广提成"
                                    maxlength="50"
                                    
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col >
                            <el-form-item label=" 上二级推广提成(%):">
                                <el-input
                                    class="inputStyle direct"
                                    v-model="formData.indirectCommissionRate"
                                    size="small"
                                    placeholder="请输入上二级推广提成"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div> -->

            <h1>商品相册</h1>
            <div class="goodsBox">
                <el-row>
                    <el-col>
                        <el-upload
                            :accept="accept"
                            :headers="headers"
                            class="upload-demo"
                            :action="uploadAction"
                            :on-success="handleGoodsImgstSuccess"
                            list-type="picture-card"
                            :file-list="goodsImagesList"
                            :before-upload="beforeUpload"
                            :on-remove="handleGoodsImgstRemove"
                        >
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </el-col>
                </el-row>
            </div>
   <!-- <h1  class="inlineBl">定制设置</h1>  
           <el-switch
           class="inlineBl"
                v-model="formData.isCustomized"
                :active-value="1"
                :inactive-value="0"
                active-text="开启"
                inactive-text="关闭"
                @change="Customization($event)"
            ></el-switch> -->
            
           <div class="goodsBox Customization"   v-if="formData.isCustomized"> 
                 <el-form :model="formData" class="signUp_Form" label-width="250px">
                    <el-row >
                        <el-col >
                            <el-form-item label="定制项:">
                                <el-checkbox-group v-model="formData.customizationItem" :min="0" :max="4">
                                    <el-checkbox
                                        v-for="(item,index) in CustomisationList"
                                        :key="index"
                                        :label="item.labelID"
                                    >{{item.labelName}}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                     <el-col >
                            <el-form-item label="定制文案长度限制：">
                                <el-input
                                    class="inputStyle direct"
                                    v-model="formData.quotationMaxLength"
                                    size="small"
                                    placeholder="请输入文案长度限制"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                 </el-form>
           </div>
            <!-- <h1>商品视频</h1>
            <div class="linkIpt">
                <el-input v-model="formData.mainVideoUrl" placeholder="请输入视频链接地址"></el-input>
            </div> -->
            <!-- <div class="goodsBox">
                <el-row>
                    <el-col>
                        <el-upload
                            :headers="headers"
                            class="upload-demo"
                            :action="uploadAction"
                            :on-success="handleGoodsImgstSuccess"
                            :file-list="goodsImagesList"
                            list-type="picture-card"
                            :before-upload="beforeUpload"
                            :on-remove="handleGoodsImgstRemove"
                        >
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </el-col>
                </el-row>
            </div>-->
            <h1>商品规格</h1>
            <div class="specification">
                <table cellspacing="0">
                    <thead>
                        <tr>
                            <th>规格名称</th>
                            <th>规格图片</th>
                            <th>规格编号</th>
                            <th>成本价</th>
                            <th>
                                <span style="color:#ff4141;">*&nbsp;&nbsp;</span>销售价
                            </th>
                            <th>条形码</th>
                            <th>起订量</th>
                            <th>限订量</th>
                            <th>排序</th>
                            <th>操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in formData.propList" :key="index">
                            <td>
                                <textarea maxlength='10' autosize v-model="item.propName"></textarea>
                            </td>
                            <td class="spePic">
                                <el-upload
                                    :accept="accept"
                                    :headers="headers"
                                    class="upload-demo"
                                    :action="uploadAction"
                                    :on-success="handleSpeSuccess"
                                    :file-list="item.fileLists"
                                    list-type="picture"
                                    :limit="1"
                                    :on-exceed="handleExceed"
                                    :before-upload="beforeUpload"
                                >
                                    <el-button
                                        size="small"
                                        type="primary"
                                        @click="uploadBtn(index)"
                                    >点击上传</el-button>
                                </el-upload>
                            </td>
                            <td>
                                <input v-model="item.propCode" type="text">
                            </td>
                            <td>
                                <input v-model="item.costPrice" type="number">
                            </td>
                            <td>
                                <input v-model="item.price" type="number">
                            </td>
                            <td>
                                <input v-model="item.barCode" type="number">
                            </td>
                            <td>
                                <input v-model="item.minBuy" type="number">
                            </td>
                            <td>
                                <input v-model="item.maxBuy" type="number">
                            </td>
                            <td>
                                <input v-model="item.sort" type="number">
                            </td>
                            <td>
                                <el-switch
                                    v-model="item.status"
                                    active-text="上架"
                                    inactive-text="下架"
                                    :active-value="1"
                                    :inactive-value="0"
                                ></el-switch>
                                <el-switch
                                    v-model="item.infinityStock"
                                    :active-value="1"
                                    :inactive-value="0"
                                    active-text="超卖"
                                    inactive-text="限购"
                                ></el-switch>
                                <el-button
                                    style="margin-top:20px;"
                                    type="danger"
                                    icon="el-icon-delete"
                                    @click="delSpecification(index)"
                                ></el-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <el-button type="success" class="addSpecification" @click="addSpecification()" v-if="!formData.isCustomized">新增规格</el-button>
            </div>
            <h1>商品详情文字描述</h1>
            <div class="linkIpt">
                <el-input  type="textarea" autosize v-model="formData.description" placeholder="请输入商品详情的文字描述"></el-input>
            </div>
            <h1>商品详情图片</h1>
            <div class="goodsBox">
                <el-row>
                    <el-col>
                        <el-upload
                            :accept="accept"
                            :headers="headers"
                            class="upload-demo"
                            :action="uploadAction"
                            :on-success="handleGoodsDescripImgstSuccess"
                            :file-list="goodsDescripImagesList"
                            list-type="picture-card"
                            :before-upload="beforeUpload"
                            :on-remove="handleGoodsDescripImgstRemove"
                        >
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </el-col>
                </el-row>
            </div>

            <h1>商品详情视频</h1>
            <div class="linkIpt">
                <el-input v-model="formData.desVideoUrl" placeholder="请输入视频链接地址"></el-input>
            </div>
            <!-- 保存 -->
            <div class="saveBox">
                <el-button @click="back">返回</el-button>
                <el-button
                    type="primary"
                    :loading="btnLoading"
                    class="add"
                    @click="confirmEdit()"
                >确认修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            loading: true,
            itemID: null,
            items: {},
            formData: {
                "itemCode": "",
                "title": "",
                "cateID": 0,
                "showCateIds": [],
                "brandID": 0,
                "unitID": 0,
                "status": 1,
                "mainVideoUrl": "",
                "desVideoUrl": "",
                "commissionPrec": 0,
                "stockWaring": 0,
                "isRecommend": 0,
                "keyword": "",
                "labelIds": [],
                "images": [],
                "description":'',
                "descripImages": [],
                "directCommissionRate":'',
                "indirectCommissionRate":'',
                "IsCustomized":1, 
                "QuotationMaxLength":0,  
                "customizationItem" : [],
                "propList": [
                    {
                        "propName": "",
                        "propCode": "",
                        "imgUrl": "",
                        "fileName": '',
                        "stock": 0,
                        "realStock": 0,
                        "costPrice": 0,
                        "price": 0,
                        "barCode": "",
                        "minBuy": 0,
                        "maxBuy": 0,
                        "status": 1,
                        "infinityStock":0,
                        "sort":0
                    }
                ],
                "id": 0,
            },
            CustomisationList: [
                    {labelID: 1,  labelName: "图案"},
                    {labelID: 2,  labelName: "语录"},
                    {labelID: 3,  labelName: "自定义"},
                ],//所有定制数据
            cateList: [],//所有分类数据
            labelList: [],//所有变标签数据
            unitList: [],//所有单位数据
            brandList: [],//所有品牌数据
            showCateIds: [],//所有展示类目数据
            cateLoading: true,
            baseUrl: this.$store.state.apiUrl,
            accept: ".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
            uploadAction: this.$store.state.apiUrl + '/api/services/app/Image/UploadImage',//上传的服务器api地址
            headers: {
                'Authorization': localStorage.getItem('accessToken'),
            },
            goodsImagesList: [],//商品相册file-list
            goodsDescripImagesList: [],//商品详情图片file-list
            uploadIndex: 0,//上传规格图片的index
            btnLoading: false,//添加按钮loading
        }
    },
    components: {
        headerNotice
    },
    created() {
        if (this.$route.query.itemID) {
            this.itemID = this.$route.query.itemID;
        }
    },
    mounted() {
        this.getSelectDatas();
    },
    methods: {
        //获取所有分类下拉等数据
        getSelectDatas() {
            let self = this;
            //获取分类
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminItem/GetCLUBList",
                success(res) {
                    self.cateList = res.cateList;
                    self.brandList = res.brandList;
                    self.labelList = res.labelList;
                    self.unitList = res.unitList;
                    self.loading = false;
                },
                fail(res) {
                }
            })
            //获取展示类目
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminCate/GetCate",
                success(res) {
                    self.showCateIds = res;
                    self.showCateIds.forEach((ele1, index1) => {
                        if (ele1.cates) {
                            ele1.cates.forEach((ele2, index2) => {
                                ele2.disabled = false;
                            })
                        }
                    })
                    self.getData();
                },
                fail(res) {
                    self.cateLoading = false;
                }
            })
        },
        //获取商品详情
        getData() {
            let self = this;
            //获取分类
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminItem/ItemDetails?itemID=" + this.itemID,
                success(res) {
                    self.formData = res;
                    // self.formData.showCateIds.forEach((ele1, index1) => {
                    //     self.showCateIds.forEach((ele2, index2) => {
                    //         if (ele2.cates) {
                    //             self.showCateIds[index2].cates.forEach((ele3, index3) => {
                    //                 if (ele3.cateID === ele1) {
                    //                     self.showCateIds[index2].cates.forEach((ele4, index4) => {
                    //                         ele4.disabled = true;
                    //                     })
                    //                     ele3.disabled = false;
                    //                 }
                    //             })
                    //         }
                    //     })
                    // })
                    if(res.isCustomized==1){
                        let cus=[];
                        self.formData.customizationItem.split(',').forEach((ele, index) => {
                            cus.push(parseInt(ele));    
                        })
                        self.formData.customizationItem=cus;
                    }else{
                       self.formData.customizationItem=[];
                    }
                    self.cateLoading = false;
                    let images = [];
                    let descripImages = [];
                    //解析返回的商品相册图片
                    res.images.forEach((ele, index) => {
                        images.push(ele.fileName);
                        self.goodsImagesList.push({
                            'name': ele.fileName,
                            'url': self.baseUrl + ele.url
                        })
                    })
                    self.formData.images = images;
                    //解析返回的商品详情图片
                    res.descripImages.forEach((ele, index) => {
                        descripImages.push(ele.fileName);
                        self.goodsDescripImagesList.push({
                            'name': ele.fileName,
                            'url': self.baseUrl + ele.url
                        })
                    })
                    self.formData.descripImages = descripImages;
                    //解析规格详情图片
                    let propList = res.propList;
                    propList.forEach((ele, index) => {
                        propList[index].fileLists = [
                            {
                                'name': ele.fileName,
                                'url': self.baseUrl + ele.imgUrl
                            }
                        ]
                    })
                    self.loading = false;
                },
                fail(res) {
                    self.cateLoading = false;
                    self.loading = false;
                }
            })
        },
        handleExceed() {
            this.$message.error('抱歉，最多上传一张图片！如更换，请删除原先图片！');
        },
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 1;
            if (file.type != 'image/jpeg' && file.type != 'image/png') {
                this.$message.error('上传的图片只支持JPG/PNG 的格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 1MB!');
            }
            return isLt2M;
        },
        //商品相册上传
        handleGoodsImgstSuccess(response, file, fileList) {
            this.formData.images.push(response.result.fileName);
            this.goodsImagesList.push({
                name: response.result.fileName,
                url: this.baseUrl + response.result.url
            });
        },
        //商品相册移除某张
        handleGoodsImgstRemove(file, fileList) {
            let self = this;
            this.goodsImagesList = fileList;
            this.formData.images = [];
            this.goodsImagesList.forEach(function (ele, index) {
                self.formData.images.push(ele.name)
            });
        },
        //商品详情图片上传
        handleGoodsDescripImgstSuccess(response, file, fileList) {
            this.formData.descripImages.push(response.result.fileName);
            this.goodsDescripImagesList.push({
                name: response.result.fileName,
                url: this.baseUrl + response.result.url
            });
        },
        //商品详情图片移除
        handleGoodsDescripImgstRemove(file, fileList) {
            let self = this;
            this.goodsDescripImagesList = fileList;
            this.formData.descripImages = [];
            this.goodsDescripImagesList.forEach(function (ele, index) {
                self.formData.descripImages.push(ele.name)
            });
        },
        //点击上传按钮 获取该条index
        uploadBtn(index) {
            this.uploadIndex = index;
        },
        //规格上传图片成功事件处理
        handleSpeSuccess(response, file, fileList) {
            this.formData.propList[this.uploadIndex].fileName = response.result.fileName;
        },
        //添加规格
        addSpecification() {
            this.formData.propList.push({
                "propName": "",
                "propCode": "",
                "imgUrl": "",
                "fileName": '',
                "stock": 0,
                "realStock": 0,
                "costPrice": 0,
                "price": 0,
                "barCode": "",
                "minBuy": 0,
                "maxBuy": 0,
                "status": 1,
                "infinityStock":0,
                "sort":0
            })
        },
        //规格删除按钮
        delSpecification(index) {
            this.formData.propList.splice(index, 1)
        },
        //展示类目点击
        cateCheckboxChange(grouopIndex, checkIndex) {
            let self = this;
            // self.showCateIds[grouopIndex].cates.forEach((ele2, index2) => {
            //     ele2.disabled = !ele2.disabled;
            // })
            // self.showCateIds[grouopIndex].cates[checkIndex].disabled = !self.showCateIds[grouopIndex].cates[checkIndex].disabled;
        },
        //确认修改商品
        confirmEdit() {
            let self = this;
            this.btnLoading = true;
            if (!this.formData.unit || !this.formData.title) {
                self.$message.error('请检查必填项是否填写！');
                self.btnLoading = false;
                return
            }
            if(this.formData.IsCustomized==0)
            {
                this.formData.QuotationMaxLength=0;
                this.formData.customizationItem=[];
            }
            self.formData.customizationItem=  self.formData.customizationItem.toString();
            self.formData.showCateId = [];
            self.showCateIds.forEach((ele) => {
                if (ele.showCateId) {
                    self.formData.showCateIds.push(ele.showCateId)
                }
            })
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminItem/EditItem",
                data: this.formData,
                success(res) {
                    self.$message({
                        message: '修改成功',
                        type: 'success'
                    });
                    self.$router.back();
                    self.btnLoading = false;
                },
                fail(res) {
                    self.btnLoading = false;
                }
            })
        },
        //取消返回
        back() {
            this.$router.back();
        },
         Customization(that){
             let self = this ;
            if(that==false){
               self.IsCustomized=false;
            }else{
               self.IsCustomized=true;
            }
          
        }
    }
}
</script>

<style lang='scss' scoped>
// 基本信息
.baseInfo {
    margin: 20px 50px;
    border: 1px solid #999;
    h1 {
        background: #f3f3f3;
        padding: 10px 20px;
        span {
            font-size: 12px;
            color: #999;
            i {
                font-style: normal;
            }
        }
    }
    .table {
        margin-top: 20px;
        .displayCate {
            display: flex;
            flex-direction: column;
            border: 1px solid #999;
            li {
                display: flex;
                flex-direction: column;
                border-bottom: 1px solid #999;
                box-sizing: border-box;
                padding: 0 20px;
                &:nth-last-child(1) {
                    border: none;
                }
                .firstName {
                    font-size: 18px;
                    color: #000;
                }
                .groupBox {
                    padding-left: 40px;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    /deep/ .radio {
                        margin: 0 20px 10px 0;
                    }
                }
            }
        }
    }
    .goodsBox {
        padding: 20px;
    }
    .specification {
        margin-top: 20px;
        width: 100%;
        box-sizing: border-box;
        padding: 0 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        table {
            width: 100%;
            table-layout: fixed;
            word-break: break-all;
            border: 1px solid #ccc;
            thead {
                width: 100%;
                th {
                    height: 50px;
                    font-size: 14px;
                    color: #666;
                    border: 1px solid #ccc;
                }
            }
            tbody tr {
                border: 1px solid #ccc;
                td {
                    height: 50px;
                    border: 1px solid #ccc;
                    vertical-align: middle;
                    text-align: center;
                    padding: 10px 0;
                    box-sizing: border-box;
                    textarea {
                        width: 80%;
                        appearance: none;
                        outline: none;
                        border: none;
                        min-height: 100px;
                        background: #f9f9f9;
                        resize: none;
                    }
                    input {
                        text-align: center;
                        width: 95%;
                        height: 80%;
                        outline: none;
                        border: none;
                        background: #f9f9f9;
                    }
                    img {
                        display: inline-block;
                        width: 100px;
                        height: 100px;
                        cursor: pointer;
                    }
                    &.spePic {
                        padding: 10px;
                    }
                }
            }
        }
        .addSpecification {
            margin: 20px 0;
        }
    }
    .saveBox {
        border-top: 1px solid #999;
        width: 100%;
        padding: 20px 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .linkIpt {
        padding: 15px 50px;
    }
     .direct{
        width: 20%;
    }
    .inlineBl{
        display: inline-block;
    }
}
</style>
<style>
</style>
